export type ManageTabId =
  | 'pending-requests'
  | 'users'
  | 'access-requests'
  | 'audit-log'
  | 'tracker-log';

/**
 * Which Manage tabs a given access level may see.
 * Pending Requests opens to editor+ (routing is a team workflow);
 * the sensitive admin tabs (Users, Access Requests, Audit, Tracker Log)
 * stay superadmin-only.
 */
const MANAGE_TAB_ACCESS: Record<ManageTabId, ReadonlySet<AdobeImsAccessLevel>> = {
  'pending-requests': new Set(['editor', 'admin', 'superadmin']),
  users: new Set(['superadmin']),
  'access-requests': new Set(['superadmin']),
  'audit-log': new Set(['superadmin']),
  'tracker-log': new Set(['superadmin']),
};

/** Can this access level reach the Manage modal at all? */
export function canOpenManage(accessLevel: AdobeImsAccessLevel): boolean {
  return accessLevel === 'editor' || accessLevel === 'admin' || accessLevel === 'superadmin';
}

/** Can this access level see a given Manage tab? */
export function canSeeManageTab(accessLevel: AdobeImsAccessLevel, tabId: ManageTabId): boolean {
  return MANAGE_TAB_ACCESS[tabId].has(accessLevel);
}

/** The list of Manage tabs visible to an access level, in sidebar order. */
export function visibleManageTabs(accessLevel: AdobeImsAccessLevel): ManageTabId[] {
  return (Object.keys(MANAGE_TAB_ACCESS) as ManageTabId[]).filter(tabId =>
    canSeeManageTab(accessLevel, tabId)
  );
}
